import { TankPlanCondition } from 'src/enums/stowage/tankPlanCondition';
import { NoonReportTypeEnum } from 'src/types/ViewModel/AolEnums';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { getCargoOnBoardByImosPortCallId } from '../stowage/manifest/cargoOnBoardUtils';

export const getCargoOnBoard = (noonReportType: NoonReportTypeEnum, imosPortCallId: number, stowagePlan: StowagePlan): number => {
    // TODO: VALIDATION - Missing input validation for imosPortCallId (should be positive number)
    // TODO: NULL-SAFETY - Missing null/undefined check for stowagePlan parameter
    const tankPlanCondition = noonReportType === NoonReportTypeEnum.Arrival ? TankPlanCondition.Arrival : TankPlanCondition.Departure;

    return getCargoOnBoardByImosPortCallId(imosPortCallId, stowagePlan, tankPlanCondition);
};
